import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/calendarios/eventos`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(evento) {
    return apiClient.post(`${evento.id}`, evento)
  },

  actualizarFT(evento) {
    return apiClient.post(`${evento.id}/fecha-tiempo`, evento)
  },

  cancelar(idEvento) {
    return apiClient.post(`${idEvento}/cancelar`)
  },

  eliminar(idEvento) {
    return apiClient.delete(`${idEvento}`)
  },

  guardar(evento) {
    return apiClient.post('', evento)
  },

  eventoJSON(idEvento, params) {
    params = params || {}
    return apiClient.get(`${idEvento}.json`, { params: params })
  },

  eventosJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/calendarios/eventos.json`, { params: params })
  },

  nPendientes: function(params) {
    params = params || {}
    return apiClient.get("n-pendientes", {params : params})
  },
  
  nEnProceso: function(params) {
    params = params || {}
    return apiClient.get("n-en-proceso", {params : params})
  }
}